var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VcAzureAcs',{staticStyle:{"height":"100vh"},attrs:{"token":_vm.token,"teamsMeetingLink":_vm.teamsLink}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }